export default {
    ACTIVITY: 1,
    CAMP: 2,
    EVENT: 3,

}
